import { defineMessages } from 'react-intl';

/** The copy of the mailbox connect guide (design outreach-v2 o1 to o7). The provider copy is in `mailboxGuideCopy.ts`. */
export const mailboxGuideMessages = defineMessages({
  dialogLabel: { id: 'app.sml.outreach.mailboxGuide.dialog', defaultMessage: 'Connect your mailbox' },
  close: { id: 'app.sml.outreach.mailboxGuide.close', defaultMessage: 'Close' },
  cancel: { id: 'app.sml.outreach.mailboxGuide.cancel', defaultMessage: 'Cancel' },
  back: { id: 'app.sml.outreach.mailboxGuide.back', defaultMessage: 'Back' },
  next: { id: 'app.sml.outreach.mailboxGuide.next', defaultMessage: 'Next' },
  connect: { id: 'app.sml.outreach.mailboxGuide.connect', defaultMessage: 'Connect' },
  done: { id: 'app.sml.outreach.mailboxGuide.done', defaultMessage: 'Done' },

  whichTitle: {
    id: 'app.sml.outreach.mailboxGuide.which.title',
    defaultMessage: 'Which email do you want to pitch from?',
  },
  whichIntro: {
    id: 'app.sml.outreach.mailboxGuide.v3.which.intro',
    defaultMessage: 'Type the address curators should answer. We find the right settings for you.',
  },
  emailLabel: { id: 'app.sml.outreach.mailboxGuide.which.email', defaultMessage: 'Email address' },
  emailPlaceholder: {
    id: 'app.sml.outreach.mailboxGuide.v3.which.emailPlaceholder',
    defaultMessage: 'you@yourband.com',
  },
  nameLabel: { id: 'app.sml.outreach.mailboxGuide.v3.which.name', defaultMessage: 'Name curators see' },
  detecting: { id: 'app.sml.outreach.mailboxGuide.which.detecting', defaultMessage: 'Looking up your mailbox…' },
  orPick: { id: 'app.sml.outreach.mailboxGuide.v3.which.orPick', defaultMessage: 'Or pick where your email is' },
  stepOf: { id: 'app.sml.outreach.mailboxGuide.v3.stepOf', defaultMessage: 'Step {step} of 3' },

  foundTitle: { id: 'app.sml.outreach.mailboxGuide.v3.found.title', defaultMessage: 'This is a {provider} address' },
  foundWorkspace: { id: 'app.sml.outreach.mailboxGuide.v3.found.workspace', defaultMessage: 'Google Workspace' },
  foundAppPassword: {
    id: 'app.sml.outreach.mailboxGuide.v3.found.appPassword',
    defaultMessage: 'Next: make an app password for Music24. 3 short steps, about 2 minutes.',
  },
  foundEmailPassword: {
    id: 'app.sml.outreach.mailboxGuide.v3.found.emailPassword',
    defaultMessage: 'Next: type the password of this mailbox. About 1 minute.',
  },
  foundNot: { id: 'app.sml.outreach.mailboxGuide.v3.found.not', defaultMessage: 'Not {provider}?' },

  trustOwnTitle: { id: 'app.sml.outreach.mailboxGuide.v3.trust.ownTitle', defaultMessage: 'From your own address' },
  trustOwnBody: {
    id: 'app.sml.outreach.mailboxGuide.v3.trust.ownBody',
    defaultMessage: 'Curators see a real person and answer you.',
  },
  trustRepliesTitle: {
    id: 'app.sml.outreach.mailboxGuide.v3.trust.repliesTitle',
    defaultMessage: 'Only pitch replies',
  },
  trustRepliesBody: {
    id: 'app.sml.outreach.mailboxGuide.v3.trust.repliesBody',
    defaultMessage: 'We read the answers to pitches. Nothing else.',
  },
  trustSlowTitle: { id: 'app.sml.outreach.mailboxGuide.v3.trust.slowTitle', defaultMessage: 'Slow, safe start' },
  trustSlowBody: {
    id: 'app.sml.outreach.mailboxGuide.v3.trust.slowBody',
    defaultMessage: '{count} pitches a day at first, so mail does not land in spam.',
  },

  unsupportedTitle: {
    id: 'app.sml.outreach.mailboxGuide.v3.unsupported.title',
    defaultMessage: '{provider} addresses cannot send pitches yet',
  },
  unsupportedGmailSub: {
    id: 'app.sml.outreach.mailboxGuide.v3.unsupported.gmailSub',
    defaultMessage: 'Free, about 2 min',
  },
  unsupportedHostName: { id: 'app.sml.outreach.mailboxGuide.v3.unsupported.hostName', defaultMessage: 'Your web host' },
  unsupportedHostSub: {
    id: 'app.sml.outreach.mailboxGuide.v3.unsupported.hostSub',
    defaultMessage: 'you@yourband.com',
  },
  unsupportedIcloudSub: {
    id: 'app.sml.outreach.mailboxGuide.v3.unsupported.icloudSub',
    defaultMessage: 'With an Apple ID',
  },

  helpTitleGmail: {
    id: 'app.sml.outreach.mailboxGuide.help.titleGmail',
    defaultMessage: 'I do not see "App passwords"',
  },
  helpTitle: { id: 'app.sml.outreach.mailboxGuide.help.title', defaultMessage: 'Something does not work?' },
  adminLink: { id: 'app.sml.outreach.mailboxGuide.help.admin', defaultMessage: 'Send your admin a message' },
  askTeammate: { id: 'app.sml.outreach.mailboxGuide.askTeammate', defaultMessage: 'Ask a teammate to do it' },
  linkCopied: { id: 'app.sml.outreach.mailboxGuide.linkCopied', defaultMessage: 'Link copied. Send it to a teammate.' },
  useAnother: { id: 'app.sml.outreach.mailboxGuide.useAnother', defaultMessage: 'Use another mailbox' },
  opened: { id: 'app.sml.outreach.mailboxGuide.opened', defaultMessage: 'Opened' },

  appPasswordLabel: { id: 'app.sml.outreach.mailboxGuide.appPassword.label', defaultMessage: 'App password' },
  appPasswordSpaces: { id: 'app.sml.outreach.mailboxGuide.appPassword.spaces', defaultMessage: 'Spaces are fine' },
  appPasswordCount: {
    id: 'app.sml.outreach.mailboxGuide.appPassword.count',
    defaultMessage: '{count} of {length} letters',
  },
  appPasswordOk: { id: 'app.sml.outreach.mailboxGuide.appPassword.ok', defaultMessage: 'All {length} letters' },
  emailPasswordLabel: { id: 'app.sml.outreach.mailboxGuide.emailPassword.label', defaultMessage: 'Email password' },

  serversFound: {
    id: 'app.sml.outreach.mailboxGuide.servers.found',
    defaultMessage: 'We found your servers at {provider}: {imap} and {smtp}.',
  },
  serversHelpTitle: {
    id: 'app.sml.outreach.mailboxGuide.servers.helpTitle',
    defaultMessage: 'We could not find the servers? Type them here',
  },
  serversHelpBody: {
    id: 'app.sml.outreach.mailboxGuide.servers.helpBody',
    defaultMessage:
      'Your host lists them on a help page called "email settings", "IMAP settings" or "mail client setup". You need two names that look like imap.yourhost.com and smtp.yourhost.com.',
  },
  imapHost: { id: 'app.sml.outreach.mailboxGuide.servers.imapHost', defaultMessage: 'Incoming (IMAP) server' },
  smtpHost: { id: 'app.sml.outreach.mailboxGuide.servers.smtpHost', defaultMessage: 'Outgoing (SMTP) server' },
  imapPort: { id: 'app.sml.outreach.mailboxGuide.servers.imapPort', defaultMessage: 'IMAP port' },
  smtpPort: { id: 'app.sml.outreach.mailboxGuide.servers.smtpPort', defaultMessage: 'SMTP port' },
  portHint: {
    id: 'app.sml.outreach.mailboxGuide.servers.portHint',
    defaultMessage: 'Not sure about the port? Leave it: we try 993 and 465, then 587.',
  },

  adminTitle: {
    id: 'app.sml.outreach.mailboxGuide.admin.title',
    defaultMessage: 'Your company mailbox needs one switch from your admin',
  },
  adminIntro: {
    id: 'app.sml.outreach.mailboxGuide.admin.intro',
    defaultMessage:
      'Work mailboxes often block apps by default. Send this message to the person who manages your email. When they reply "done", come back and press Connect.',
  },
  adminCopy: { id: 'app.sml.outreach.mailboxGuide.admin.copy', defaultMessage: 'Copy the message' },
  adminCopied: { id: 'app.sml.outreach.mailboxGuide.admin.copied', defaultMessage: 'Copied' },
  adminOpenMail: { id: 'app.sml.outreach.mailboxGuide.admin.openMail', defaultMessage: 'Open in my email' },
  adminDone: { id: 'app.sml.outreach.mailboxGuide.admin.done', defaultMessage: 'My admin did it, connect' },

  checkingTitle: { id: 'app.sml.outreach.mailboxGuide.check.title', defaultMessage: 'Checking your mailbox' },
  checkFound: { id: 'app.sml.outreach.mailboxGuide.check.found', defaultMessage: 'Found your mailbox' },
  checkRead: { id: 'app.sml.outreach.mailboxGuide.check.read', defaultMessage: 'Signed in to read the replies' },
  checkSend: { id: 'app.sml.outreach.mailboxGuide.check.send', defaultMessage: 'Signing in to send pitches' },
  checkNote: {
    id: 'app.sml.outreach.mailboxGuide.check.note',
    defaultMessage: 'We send nothing and read nothing now. About 10 seconds.',
  },

  errAuthTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.authTitle',
    defaultMessage: '{provider} said the password is wrong',
  },
  errAuthBodyApp: {
    id: 'app.sml.outreach.mailboxGuide.err.authBodyApp',
    defaultMessage:
      'Check that you copied the whole app password. If you closed it, make a new one: {provider} shows each one only once.',
  },
  errAuthBodyEmail: {
    id: 'app.sml.outreach.mailboxGuide.err.authBodyEmail',
    defaultMessage: 'Check the password. It is the one you use to read this email in the browser of your host.',
  },
  errNormalTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.normalTitle',
    defaultMessage: 'Your normal password does not work here',
  },
  errNormalBody: {
    id: 'app.sml.outreach.mailboxGuide.err.normalBody',
    defaultMessage:
      'You typed the password you use to sign in. {provider} needs an app password instead. It takes 2 minutes.',
  },
  errHostTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.hostTitle',
    defaultMessage: 'We could not reach {host}',
  },
  errHostBody: {
    id: 'app.sml.outreach.mailboxGuide.err.hostBody',
    defaultMessage: 'Check the server name on your host\'s help page. It often starts with "imap." or "mail.".',
  },
  errTlsTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.tlsTitle',
    defaultMessage: 'The secure connection to your mailbox failed',
  },
  errTlsBody: {
    id: 'app.sml.outreach.mailboxGuide.err.tlsBody',
    defaultMessage: 'Check the server names and the ports, or leave the ports empty so we try the usual ones.',
  },
  errSmtpTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.smtpTitle',
    defaultMessage: 'Your company blocks sending from apps',
  },
  errSmtpBody: {
    id: 'app.sml.outreach.mailboxGuide.err.smtpBody',
    defaultMessage: 'Your mail server does not let apps send email. Your admin can turn it on in 1 minute.',
  },
  errImapTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.imapTitle',
    defaultMessage: 'IMAP is off for this mailbox',
  },
  errImapBody: {
    id: 'app.sml.outreach.mailboxGuide.err.imapBody',
    defaultMessage: 'Turn on IMAP access in the settings of your mailbox, then try again.',
  },
  errUnsupportedTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.unsupportedTitle',
    defaultMessage: 'This mailbox does not work with Music24',
  },
  errUnsupportedBody: {
    id: 'app.sml.outreach.mailboxGuide.err.unsupportedBody',
    defaultMessage: 'Use another mailbox, for example Gmail or the email of your web host.',
  },
  errTakenTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.takenTitle',
    defaultMessage: 'Another person of your team connected this address',
  },
  errTakenBody: {
    id: 'app.sml.outreach.mailboxGuide.err.takenBody',
    defaultMessage: 'Only the workspace owner or the person who connected it can connect it again.',
  },
  errLimitTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.limitTitle',
    defaultMessage: 'Your plan has no room for one more mailbox',
  },
  errLimitBodyOwner: {
    id: 'app.sml.outreach.mailboxGuide.err.limitBodyOwner',
    defaultMessage: 'Pick a plan with more mailboxes, or send from a mailbox you connected already.',
  },
  errLimitBodyMember: {
    id: 'app.sml.outreach.mailboxGuide.err.limitBodyMember',
    defaultMessage: 'Ask the workspace owner for a plan with more mailboxes.',
  },
  seePlans: { id: 'app.sml.outreach.mailboxGuide.err.seePlans', defaultMessage: 'See the plans' },
  errSupportPausedTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.supportPausedTitle',
    defaultMessage: 'Music24 support paused this address',
  },
  errSupportPausedBody: {
    id: 'app.sml.outreach.mailboxGuide.err.supportPausedBody',
    defaultMessage: 'Write to support to send from it again.',
  },
  errDemoTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.demoTitle',
    defaultMessage: 'The example artist cannot connect a mailbox',
  },
  errDemoBody: {
    id: 'app.sml.outreach.mailboxGuide.err.demoBody',
    defaultMessage: 'Pick one of your own artists to connect your mailbox.',
  },
  errUnknownTitle: {
    id: 'app.sml.outreach.mailboxGuide.err.unknownTitle',
    defaultMessage: 'We could not connect your mailbox',
  },
  errUnknownBody: {
    id: 'app.sml.outreach.mailboxGuide.err.unknownBody',
    defaultMessage: 'Check the address and the password, then try again.',
  },
  showAnswer: {
    id: 'app.sml.outreach.mailboxGuide.err.showAnswer',
    defaultMessage: 'Show what the server answered',
  },
  showMeHow: { id: 'app.sml.outreach.mailboxGuide.err.showMeHow', defaultMessage: 'Show me how' },
  editServers: { id: 'app.sml.outreach.mailboxGuide.err.editServers', defaultMessage: 'Edit the servers' },
  adminMessageButton: {
    id: 'app.sml.outreach.mailboxGuide.err.adminMessage',
    defaultMessage: 'Get the message for my admin',
  },
  tryAgain: { id: 'app.sml.outreach.mailboxGuide.err.tryAgain', defaultMessage: 'Try again' },

  connectedTitle: { id: 'app.sml.outreach.mailboxGuide.connected.title', defaultMessage: '{address} is connected' },
  connectedBody: {
    id: 'app.sml.outreach.mailboxGuide.connected.body',
    defaultMessage:
      'Plug starts slowly with 3 pitches a day and sends more over 3 weeks, so your mailbox stays out of spam.',
  },
  testTitle: { id: 'app.sml.outreach.mailboxGuide.test.title', defaultMessage: 'Send yourself a test pitch' },
  testBody: {
    id: 'app.sml.outreach.mailboxGuide.test.body',
    defaultMessage: 'See exactly what curators get, from your own address.',
  },
  testButton: { id: 'app.sml.outreach.mailboxGuide.test.button', defaultMessage: 'Send me a test' },
  testSent: { id: 'app.sml.outreach.mailboxGuide.test.sent', defaultMessage: 'We sent a test pitch to {to}.' },
  testFailed: {
    id: 'app.sml.outreach.mailboxGuide.test.failed',
    defaultMessage: 'The test pitch did not go out. Try again in a minute.',
  },
});
